// Template code compare 
export const TEMPLATE_CIT_COMPARE = "cash_in_transit";
export const TEMPLATE_SME_KIRANA_COMPARE = "sme_kirana";
export const TEMPLATE_ALPA_BIMA_COMPARE = "alpa_bima";
export const TEMPLATE_CYBER_COMPARE = "cyber";
export const TEMPLATE_SBI_HC_COMPARE = "sbi_hc";
export const TEMPLATE_ATM_COMPARE = "atm";
// TemplateCodes.js

// Individual template code constants
export const TEMPLATE_SME_KIRANA_50K = "sme_kirana_50k";
export const TEMPLATE_SME_KIRANA_100K = "sme_kirana_100k";
export const TEMPLATE_SME_KIRANA_200K = "sme_kirana_200k";
export const TEMPLATE_SME_KIRANA_300K = "sme_kirana_300k";
export const TEMPLATE_SME_KIRANA_400K = "sme_kirana_400k";
export const TEMPLATE_SME_KIRANA_500K = "sme_kirana_500k";

export const TEMPLATE_ATM_100K = "atm_100";

export const TEMPLATE_CIT_123 = "cash_in_transit_123";
export const TEMPLATE_CIT_1000 = "cash_in_transit_1000";

export const TEMPLATE_ALPA_BIMA_500 = "alpa_bima_500";
export const TEMPLATE_ALPA_BIMA_1000 = "alpa_bima_1000";
export const TEMPLATE_SBI_HC_399 = "sbi_hc_399";
export const TEMPLATE_SBI_HC_499 = "sbi_hc_499";

export const TEMPLATE_CYBER_50 = "cyber_50k";
export const TEMPLATE_CYBER_25 = "cyber_25k";
export const TEMPLATE_CYBER_100 = "cyber_100k";

// Grouped constants using individual constants
export const SME_KIRANA_TEMPLATE_CODES = [
  TEMPLATE_SME_KIRANA_50K,
  TEMPLATE_SME_KIRANA_100K,
  TEMPLATE_SME_KIRANA_200K,
  TEMPLATE_SME_KIRANA_300K,
  TEMPLATE_SME_KIRANA_400K,
  TEMPLATE_SME_KIRANA_500K,
];
export const ATM_TEMPLATE_CODES = [
  TEMPLATE_ATM_100K
];
export const CIT_TEMPLATE_CODES = [
  TEMPLATE_CIT_123,
  TEMPLATE_CIT_1000
];

export const CYBER_CRIME_TEMPLATE_CODES = [
  TEMPLATE_CYBER_25,
  TEMPLATE_CYBER_50,
  TEMPLATE_CYBER_100
]

export const ALPA_BIMA_SBI_HC_TEMPLATE_CODES = [
  TEMPLATE_ALPA_BIMA_500,
  TEMPLATE_ALPA_BIMA_1000,
  TEMPLATE_SBI_HC_399,
  TEMPLATE_SBI_HC_499,
];
export const ALPA_BIMA_TEMPLATE_CODES = [
  TEMPLATE_ALPA_BIMA_500,
  TEMPLATE_ALPA_BIMA_1000,
];
export const SBI_HC_TEMPLATE_CODES = [
  TEMPLATE_SBI_HC_399,
  TEMPLATE_SBI_HC_499,
];
